import { render, staticRenderFns } from "./inquiryDetail.vue?vue&type=template&id=44f69f4a&scoped=true"
import script from "./inquiryDetail.vue?vue&type=script&lang=js"
export * from "./inquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./inquiryDetail.vue?vue&type=style&index=0&id=44f69f4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f69f4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f69f4a')) {
      api.createRecord('44f69f4a', component.options)
    } else {
      api.reload('44f69f4a', component.options)
    }
    module.hot.accept("./inquiryDetail.vue?vue&type=template&id=44f69f4a&scoped=true", function () {
      api.rerender('44f69f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/inquiry/inquiryDetail.vue"
export default component.exports